$(document).ready(function() {

    var progressPath = document.querySelector('.progress-wrap path');
    if ( progressPath ) {
        var pathLength = progressPath.getTotalLength();
        progressPath.style.transition = progressPath.style.WebkitTransition = 'none';
        progressPath.style.strokeDasharray = pathLength + ' ' + pathLength;
        progressPath.style.strokeDashoffset = pathLength;
        progressPath.getBoundingClientRect();
        progressPath.style.transition = progressPath.style.WebkitTransition = 'stroke-dashoffset 10ms linear';

        var updateProgress = function () {
            var scroll = $(window).scrollTop();
            var height = $(document).height() - $(window).height();
            var progress = pathLength - (scroll * pathLength / height);
            progressPath.style.strokeDashoffset = progress;
        }

        updateProgress();
        $(window).scroll(updateProgress);

        var offset = 50;
        var duration = 550;

        jQuery(window).on('scroll', function () {
            if (jQuery(this).scrollTop() > offset) {
                jQuery('.progress-wrap').addClass('active-progress');
            } else {
                jQuery('.progress-wrap').removeClass('active-progress');
            }
        });

        jQuery('.progress-wrap').on('click', function (event) {
            event.preventDefault();
            jQuery('html, body').animate({scrollTop: 0}, duration);
            return false;
        })
    }
});
window.playingIndex = 0;

window.stopTextToAudio = function() {
    window.playingIndex = 4;
    window.speechSynthesis.cancel();
    setTimeout(function (){
        window.playingIndex = 0;
    },500);
}

window.onbeforeunload = function(){
    stopTextToAudio();
};

window.speakMessage = function ( lang, PAUSE_MS = 500, action = 'play') {
    try {
        const messageParts = [
            document.getElementById('title').innerText,
            document.getElementById("introText").innerText,
            document.getElementById('fulltext').innerText
        ]


        const speak = (textToSpeak) => {
            const msg = new SpeechSynthesisUtterance();
            msg.volume = 1; // 0 to 1
            msg.rate = 1; // 0.1 to 10
            msg.pitch = .1; // 0 to 2
            msg.text = textToSpeak;
            msg.lang = lang;
            msg.onend = function() {
                window.playingIndex++;
                if (window.playingIndex < messageParts.length) {
                    setTimeout(() => {
                        speak(messageParts[window.playingIndex])
                    }, PAUSE_MS)
                }
            };
            speechSynthesis.speak(msg);
        }
        speak(messageParts[0])
    } catch (e) {
        console.error(e)
    }
}
document.addEventListener('DOMContentLoaded', function () {
    loadJS("https://cdnjs.cloudflare.com/ajax/libs/OwlCarousel2/2.3.4/owl.carousel.min.js");
});
